import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 50px);
  height: calc(100% - 50px);
  align-items: flex-start;
  justify-content: center;
  padding: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Medicao = styled.label`
  font-size: 13px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.label};
`;

export const Value = styled.label`
  font-size: 40px;
  font-weight: 600;
  color: ${(props) => props.color};
`;
